import { render, staticRenderFns } from "./InspirationDetailModal.vue?vue&type=template&id=33f8b372&scoped=true"
import script from "./InspirationDetailModal.vue?vue&type=script&lang=js"
export * from "./InspirationDetailModal.vue?vue&type=script&lang=js"
import style0 from "./InspirationDetailModal.vue?vue&type=style&index=0&id=33f8b372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f8b372",
  null
  
)

export default component.exports